<template>
  <div class="yhStoreManageList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <!-- 关键字搜索 -->
          <el-input class="searchInput" v-model="shopName"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_deviceManagement_name')"></el-input>
        </el-form-item>
        <!-- 所在楼层 -->
        <el-form-item>
          <el-select v-model="houseId">
             <el-option key label="请选择楼层" value></el-option>
						<el-option v-for="(item,index) in houseList" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
        <!-- 商户分类 -->
        <el-form-item>
          <el-select v-model="shopType1">
            <el-option key label="请选择分类" value></el-option>
            <el-option v-for="(item,index) in shopType1List" :key="index" :label="item.name" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 查询按钮 -->
        <el-button type="primary" @click="commit">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <!-- 添加商户 -->
      <el-button type="primary" slot="header" @click="add">添加商户</el-button>

      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <!-- 序号功能 -->
        <el-table-column type="index" :index="indexMethod" :label="$t('lang.lab_index')" align="center" width="100px">
        </el-table-column>
        <!-- 所属项目 -->
        <!-- <el-table-column prop="gardenName" label="所属项目"></el-table-column> -->
        <!-- 所属楼层 -->
        <el-table-column prop="houseName" label="所在楼层"></el-table-column>
        <!-- 商户名称 -->
        <el-table-column prop="shopName" label="商户名称"></el-table-column>
        <!-- 商户编号 -->
        <el-table-column prop="shopNo" label="商户编号"></el-table-column>
        <!-- 商户分类 -->
        <el-table-column label="商户分类">
          <template slot-scope="scope">
						{{scope.row.shopType1? scope.row.shopType1: '--'}}
					</template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')"
          :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <!-- 修改商户 -->
            <el-button @click="edit(scope.row.id)">修改</el-button>
            <!-- 删除商户 -->
            <el-button class="orange" @click="deletetable(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50,1000]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  export default {
    name: '/manage/main.yhStoreManageList',
    data() {
      return {
        houseList: [], // 楼层列表
        gardenId: this.$store.getters.gardenId,
        houseId: '',
        pageCount: 0, // 总页数
        pageNo: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
        isDisabled: true, // 保存的可点击
        isAdd: false, // 标识新增(true)或编辑(false)
        multipleSelection: [], // 多选框
        shopName: '', // 关键字查询
        name: '', // 商户名称
        fileList: [],
        shopType1: '', // 商户分类
        shopType1List: [
					{
						name: '全部',
					},
					{
						name: '创意/生活',
					},
					{
						name: '时尚/潮流',
					},
					{
						name: '主力店',
					},
					{
						name: '童真',
					},
          {
						name: '影院',
					},
          {
						name: '数码电器',
					},
				], // 商户分类列表
      }
    },
    watch: {
      gardenId: function (newVal, oldVal) {
        this.commit()
        this.getHouseList()
      },
      shopType1: function (newVal, oldVal) {
        if (newVal == '全部') {
          this.shopType1 = ''
        }
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('yhStoreManagementForm', '')
      }, 200)
      this.getHouseList()
      this.getTablelist()
    },
    activated() {
      this.getTablelist()
    },
    methods: {
      // 列表隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 获取楼层列表
      getHouseList() {
        let loading = this.$loading()
				this.$get(`/gardenGrids?gardenGridsName=&type=1&isShop=1&parentId=${this.gardenId}&pageNo=1&pageSize=999`).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.houseList = res.list
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
      },
      // 设备管理列表
      getTablelist() {
        let loading = this.$loading()
        this.$get(
          `/gardenShop?shopName=${this.shopName}&shopType1=${this.shopType1}&gardenId=${this.gardenId}&houseId=${this.houseId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getTablelist()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getTablelist()
      },
      edit(id) {
        window.localStorage.setItem('yhStoreManagementForm', '')
        this.$router.push({
          name: 'yhStoreManageAdd',
          query: {
            id: id
          }
        })
      },
      add() {
        window.localStorage.setItem('yhStoreManagementForm', '')
        this.$router.push({
          name: 'yhStoreManageAdd'
        })
      },
      commit() {
        this.pageNo = 1
        this.getTablelist()
      },
      deletetable(id) {
        let loading = this.$loading()
        this.$confirm(
            this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            }
          ).then(() => {
            // 添加del的url
            this.$delete(`/gardenShop/` + id).then(res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              })
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang="scss">
  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .deviceManagementList .upload-demo {
    display: inline;
    padding-left: 20px;
  }
</style>